import { render, staticRenderFns } from "./MasterComponent.vue?vue&type=template&id=79049a64"
import script from "./MasterComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./MasterComponent.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports